import { TextField } from "@mui/material";
import React from "react";

const CommonTextArea = ({ label, placeholder, name, value, onChange, error,customStyles,textAreaStyles,required }: any) => (
    <div className="w-full flex items-start flex-col gap-4 justify-center" style={{...customStyles}}>
      <label className="text-textGray text-[0.8rem]">{label} {required && <span className="text-red-500">*</span>}</label>
      <TextField
        placeholder={placeholder}
        fullWidth
        multiline
        minRows={3}
        name={name}
        value={value}
        onChange={onChange}
        error={!!error}
        helperText={error}
        variant="outlined"
        sx={{
          ...textAreaStyles,
          "& .MuiOutlinedInput-root": {
            backgroundColor: "transparent",
            "& fieldset": {
              border: "1px solid #151B2D4D",
            },
          },
          "& textarea": {
            fontSize: "0.8rem",
          },
        }}
      />
    </div>
  );
  

export default CommonTextArea;
